import React, { useEffect, useState } from 'react'
import { ProductCard } from '../../../components'



export const FeaturedProduct = () => {
  // const [products, setProducts] = useState([]);
  const [cmsProducts, setCmsProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  

   
 


const getFeaturedProductsCms = async () => {

  // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/products?populate[poster][populate]=*&filters[best_seller][$eq]=true`)
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products?populate[poster][populate]=*&filters[best_seller][$eq]=true`)
  // const response = await fetch("/.netlify/functions/cmsComunecation", {
    // method: "POST",
    // body: JSON.stringify({
    //   request_type: "get_Featured_Product"
    // })
  
  const data = await response.json()
  console.log("getFeaturedProducts", data)
  if(response.ok){
    // console.log("get_featured_products_netlify_serverless", data)
  
    setCmsProducts(data.data)
    setLoading(false)
  }
  // data.map((item)=>{
  //   console.log("item", item)
  // })
  // console.log("getFeaturedProducts", data)
}
  useEffect(()=>{

    // async function fetchProducts(){
    //   const get_featured_products_netlify_serverless = await fetch("/.netlify/functions/getProducts" , {
    //     method: "POST" , 
    //     body: JSON.stringify({
    //       request_type: "featured_products"
    //     })
    //   })
    //      const data = await get_featured_products_netlify_serverless.json()
    //   if(get_featured_products_netlify_serverless.ok){
    //     // console.log("get_featured_products_netlify_serverless", data)
    //     setProducts(data)
    //     setLoading(false)
    //   }

    // }
    // fetch_products()
    getFeaturedProductsCms()
    // fetchProducts()
 
  },[])

  

  if(loading){
    return <div>Loading...</div>
  }
  
  return (
    
    <section className=" justify-between items-center mx-auto max-w-screen-xl">
   
      <h1 className="text-2xl text-center font-semibold dark:text-slate-100 mb-5 underline underline-offset-8">Featured eBooks</h1>    
    <div className="flex flex-wrap justify-center lg:flex-row">
    {/* here we can choose how many products to show in the featured section */}
      {/* {products.map((product, index)=> 
      <ProductCard key={index} data={product} />
      )} */}
        {/* here we can choose how many products to show in the featured section */}
      
        {cmsProducts.length > 0 ? cmsProducts.map((product, index)=> 
      <ProductCard key={index} data={product} />
      ) : <p>No products found</p>}
    </div>

    </section>
  )
}
